import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { ChevronDown } from 'lucide-react';

const SelectDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ChevronDown size={16} className="text-gray-400" />
  </components.DropdownIndicator>
);

SelectDropdownIndicator.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SelectDropdownIndicator;
